<template>
  <div>
    <!-- ALERT UNCONFIRMED ACCOUNT -->
    <v-alert v-if="unConfirmedUser && ! isUserFirstminutes" color="warningorange" type="warning" icon="fas fa-envelope" prominent class="px-12 mb-0 mt-1" style="border-radius: 0">
      <template v-if="! sendEmailConfirmationDone">
        {{ $t('ALERT_BANNERS.UNCONFIRMED_ACCOUNT') }}
        <v-btn :loading="sendEmailConfirmationInProgress" outlined class="ml-2" @click="sendEmailConfirmation()">
          {{ $t('ALERT_BANNERS.RESEND_EMAIL_CONFIRMATION') }}
        </v-btn>
      </template>
      <span v-else>{{ $t('ALERT_BANNERS.EMAIL_CONFIRMATION_SENT_TO') }} {{ user.email }}</span>
    </v-alert>
    <!-- ALERT SLOW BROWSER -->
    <v-alert v-if="isSlowBrowser" color="warningorange" type="warning" icon="fas fa-exclamation-triangle" prominent dismissible class="px-12 mb-0 mt-1" style="border-radius: 0">
      Vous utilisez Internet Explorer, un navigateur ancien qui offre des performances bien en dessous des standards actuels.<br>
      Pour une meilleure expérience, <b>nous vous recommandons vivement de choisir un autre navigateur</b>.
    </v-alert>
  </div>
</template>

<script>
  const ua = window.navigator.userAgent || '';
  const isSlowBrowser = ua.indexOf('Trident/') > 0 || ua.indexOf('MSIE ') > 0;

  export default {
    data() {
      return {
        isSlowBrowser,
        sendEmailConfirmationInProgress: false,
        sendEmailConfirmationDone: false,
      };
    },
    computed: {
      user() { return this.$store.state.users.user; },
      unConfirmedUser() { return this.user.id && ! this.user.confirmed; },
      isUserFirstminutes() {
        if (! this.user.created_at) return true;
        const userCreatedAt = moment(this.user.created_at); // will not be reactive as created_at never changes
        return moment().add(-10, 'minutes').isBefore(userCreatedAt) && userCreatedAt.isBefore();
      },
    },
    methods: {
      sendEmailConfirmation() {
        this.sendEmailConfirmationInProgress = true;
        window.apiSrv.call('users/sendemailconfirmation', 'index').then(() => {
          this.sendEmailConfirmationInProgress = false;
          this.sendEmailConfirmationDone = true;
        }).catch((message) => {
          this.sendEmailConfirmationInProgress = false;
          if (message) this.$store.dispatch('ui/msgbox/open', { title: "Error : Email confirmation could not be sent", body: `${message || "Something went wrong."}` });
        });
      },
    },
  };
</script>
